import React, { Component } from "react";

import Link from "components/link/link";

import "./flashHeader.css";

export default class FlashHeader extends Component {
  render() {
    return (
      <div
        className={`flashHeader ${this.props.flash === true ? "flash" : ""}`}
      >
        <p>
          This item has been added to your <Link to="/cart">Cart →</Link>
        </p>
      </div>
    );
  }
}
